import { Stepper } from "@mantine/core";
import { Badge } from "@xplatform/design-system";
import { IconCheck } from "@tabler/icons-react";
import { translateStepType } from "@utils/flowTypeTranslations";
import { useTranslation } from "@hooks/useTranslation";
import type { FlowStepFormData } from "@utils/builders/flowConfig";
import "./FlowStepStepper.scss";

interface FlowStepStepperProps {
    steps: FlowStepFormData[];
    activeStep: number;
    isStepValid: (index: number) => boolean;
}

export const FlowStepStepper = ({
    steps,
    activeStep,
    isStepValid,
}: FlowStepStepperProps) => {
    const { t } = useTranslation();

    return (
        <Stepper active={activeStep} className="flow-step-stepper">
            {steps.map((step, index) => (
                <Stepper.Step
                    key={index}
                    label={translateStepType(step.stepType, t)}
                    completedIcon={<IconCheck size={16} />}
                    description={
                        isStepValid(index) ? (
                            <Badge
                                color="green"
                                size="xs"
                                leftSection={<IconCheck size={10} />}
                                className="flow-step-stepper__chip"
                            >
                                Configured
                            </Badge>
                        ) : null
                    }
                />
            ))}
        </Stepper>
    );
};
